export const operatorList = (): any => {
  const operators = {
    "+": "+",
    "-": "-",
    "/": "÷",
    "*": "×",
  };
  return operators;
};
